(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
    console.log('debug');
    const stickyBar = document.querySelector('.sticky-add-to-cart__bar');
    const floatWrapper = document.querySelector('#gt_float_wrapper');

    if (!stickyBar || !floatWrapper) return;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-stuck') {
          const isStuck = stickyBar.getAttribute('data-stuck') === 'true';
          
          if (isStuck) {
            floatWrapper.style.setProperty('bottom', '120px', 'important');
            floatWrapper.style.transition = 'bottom 0.3s ease';
          } else {
            floatWrapper.style.setProperty('bottom', '20px', 'important');
          }
        }
      });
    });

    // Start observing the sticky bar
    observer.observe(stickyBar, {
      attributes: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
